import React, {useEffect, useState} from 'react';
import {TicketType} from "types/TicketType";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";

type Props = {
    ticketType: TicketType | null
    show: boolean
    onDelete?: (ticketType: TicketType) => any
    onDeleteFail?: (ticketType: TicketType, error: unknown) => any
    onCancel?: () => any
}

function DeleteTicketType(props: Props) {
    const {ticketType, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(ticketType?.name || 'this ticket type');
    const {mutateAsync: deleteTicketType} = useMutation(ngage.ticketTypes.destroy)

    useEffect(() => {
        if(ticketType) setName(ticketType.name)
    }, [ticketType]);

    async function handleDeleteTicketType() {
        if (ticketType) {
            try {
                await deleteTicketType(ticketType.id)
                await invalidate('ticket-types.all')

                if (onDelete) onDelete(ticketType)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(ticketType, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Ticket Type"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteTicketType}
            onCancel={handleCancel}
        />
    );
}

export default DeleteTicketType;